module.exports = __webpack_public_path__ + "static/media/3fef4f31f944477f5f3e9643cbcaab7a.3df8ea1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/3fef4f31f944477f5f3e9643cbcaab7a.svg
// module id = 1260
// module chunks = 21